import Client from "../client/ClientNotication"
const resource = "/api/v1"

const getCount = () => {
  return Client.get(`${resource}/notification-count`)
}
const getTabs = () => {
  return Client.get(`${resource}/get-tab-notification`)
}
const getNottOfTabs = (params) => {
  return Client.get(`${resource}/list-notification`, { params })
}
const getDetailNoti = (params) => {
  return Client.get(`${resource}/get-notification-by-noti-id`, { params })
}

const markReadNotication = (id) => {
  return Client.put(`${resource}/mark-read-by-noti-id?noti_id=${id}`)
}

const markReadNotis = (data) => {
  return Client.put(`${resource}/mark-read`, data)
}
const userRepository = {
  getCount,
  getTabs,
  getNottOfTabs,
  getDetailNoti,
  markReadNotication,
  markReadNotis
}
export default userRepository
